import React, { useEffect, useState } from 'react';
import { collection, getDocs } from 'firebase/firestore';
import { db } from '../firebase';
import { Link } from 'react-router-dom';

function ListingPage() {
  const [listings, setListings] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchListings = async () => {
      try {
        const querySnapshot = await getDocs(collection(db, 'listings'));
        const items = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
        setListings(items);
      } catch (err) {
        console.error("Failed to fetch listings:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchListings();
  }, []);

  if (loading) return <div className="p-8">Loading listings...</div>;

  if (!listings.length) return <div className="p-8 text-red-600">No listings found. Double-check Firestore and data format.</div>;

  return (
    <div className="bg-bone min-h-screen p-8 text-charcoal">
      <h2 className="text-3xl font-bold mb-6">Available Listings</h2>
      <div className="grid gap-6 grid-cols-1 sm:grid-cols-2 md:grid-cols-3">
        {listings.map(listing => (
          <Link
            to={`/listings/${listing.id}`}
            key={listing.id}
            className="bg-white shadow-md rounded overflow-hidden hover:shadow-lg transition duration-200 block"
          >
            {listing.imageUrl && (
              <img
                src={listing.imageUrl}
                alt={listing.title}
                className="w-full h-48 object-cover"
              />
            )}
            <div className="p-4">
              <h3 className="text-xl font-semibold mb-2">{listing.title}</h3>
              <p className="text-sm mb-1">Price: ${listing.price}</p>
              <p className="text-sm mb-1">Sex: {listing.sex}</p>
              <p className="text-sm mb-1">Traits: {listing.traits}</p>
              <p className="text-sm text-gray-600 truncate">{listing.description}</p>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}

export default ListingPage;
